import { Box, styled, TableRow, TableCell, Button, Tab, Tabs, Grid, Autocomplete, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';

import { Link } from 'react-router-dom';
import { TabContext, TabPanel } from '@mui/lab';
import { api } from '../../../api';

import { PMTResponse, TrackingCardPMT, TrackingCardVHM } from '../../../schema/external';
import MultiSelect from '../../../components/MultiSelect';
import SearchIcon from '@mui/icons-material/Search';

enum TrackingCardTab {
  PMT = 'PMT',
  VHM = 'VHM'
}

const TrackingCard: React.FC = () => {
  const [PMTList, setPMTList] = useState<TrackingCardPMT[]>([]);
  const [VHMList, setVHMList] = useState<TrackingCardVHM[]>([]);
  const [PMTListBackup, setPMTListBackup] = useState<TrackingCardPMT[]>([]);
  const [VHMListBackup, setVHMListBackup] = useState<TrackingCardVHM[]>([]);
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [value, setValue] = useState<TrackingCardTab>(TrackingCardTab.PMT);
  const [filterID, setFilterID] = useState<string>('');
  const [filterDeviceID, setFilterDeviceID] = useState<string>('');
  const [filterStatus, setFilterStatus] = useState<string>('');

  const [filterIDVHM, setFilterIDVHM] = useState<string>('');
  const [filterDeviceIDVHM, setFilterDeviceIDVHM] = useState<string>('');
  const [filterStatusVHM, setFilterStatusVHM] = useState<string>('');
  const [filterLicenseVHM, setFilterLicenseVHM] = useState<string>('');

  const handleChange = (event: React.SyntheticEvent, newValue: TrackingCardTab) => {
    setValue(newValue);
  };

  // const handlePageChange = (_: unknown, newPage: number) => {
  //   setPage(newPage);
  // };

  // const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  useEffect(() => {
    api.get<PMTResponse<TrackingCardPMT[]>>(`bypass/pmt`).then((res) => {
      const { data } = res;
      if (data.data) {
        setPMTList(data.data);
        const temp = JSON.stringify(data.data)
        setPMTListBackup(JSON.parse(temp))
      }
    });
    api.get<TrackingCardVHM[]>(`bypass/vhm`).then((res) => {
      const { data } = res;
      setVHMList(data);
      const temp = JSON.stringify(data)
      setVHMListBackup(JSON.parse(temp))
    });
  }, [value]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const bcx = PMTListBackup
      const result = 
        bcx
        .filter((x) => x.dev_eui?.includes(filterDeviceID))
        .filter((x) => x.occupied_id?.includes(filterID))
        .filter((x) => x.status.includes(filterStatus))
      
      setPMTList(result);
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [
    filterDeviceID,
    filterID,
    filterStatus
  ]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const result = VHMListBackup
        .filter((x) => (filterDeviceIDVHM ? x.imei_id?.includes(filterDeviceIDVHM) : true))
        .filter((x) => (filterID ? x.person_id?.includes(filterID) : true))
        .filter((x) => (filterStatusVHM ? x.status === filterStatusVHM : true))
        .filter((x) => (filterLicenseVHM ? x.license_plate === filterLicenseVHM : true));

      setVHMList(result);
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [
    filterDeviceIDVHM,
    filterIDVHM,
    filterStatusVHM,
    filterLicenseVHM
  ]);

  return (
    <Container>
      <Box display="flex" justifyContent="space-between">
        <PageHeader text="หมายเลขอุปกรณ์ติดตาม" />
        {/* <Button variant="outlined" color="primary">
            Export
          </Button> */}
        {/* <Button
          component={Link} to={`/tracking-card/create`}
          variant="contained"
          color="primary"
          sx={{ marginRight: 1 }}
        >
          เพิ่ม
        </Button> */}
      </Box>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          <Tab value={TrackingCardTab.PMT} label="อุปกรณ์ติดตามบุคคล" />
          <Tab value={TrackingCardTab.VHM} label="อุปกรณ์ติดตามพาหนะ" />
        </Tabs>
        <TabPanel value={TrackingCardTab.PMT}>
        <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="หมายเลขบัตร"
              variant="outlined"
              placeholder="หมายเลขบัตร"
              value={filterDeviceID}
              onChange={(e) => {
                setFilterDeviceID(e.target.value);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="เลขบัตรประชาชน"
              variant="outlined"
              placeholder="เลขบัตรประชาชน"
              value={filterID}
              onChange={(e) => {
                setFilterID(e.target.value);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <FormControl fullWidth>
              <InputLabel id="select-status-label">สถานะ</InputLabel>
              <Select
                labelId="select-status-label"
                value={filterStatus}
                label="สถานะ"
                name="status"
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                <MenuItem value="Online">Online</MenuItem>
                <MenuItem value="Offline">Offline</MenuItem>
                <MenuItem value="Occupied">Occupied</MenuItem>
                <MenuItem value="Lost">Lost</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
          <Box sx={{ padding: '24px 0' }}>
            <Table
              heads={['หมายเลขบัตร', 'ชื่ออุปกรณ์', 'สถานะ', 'เลขบัตรประชาชน', 'ชื่อ นามสกุล', 'เพิ่มเติม']}
              count={PMTList.length}
              // page={page}
              // rowsPerPage={rowsPerPage}
              // onPageChange={handlePageChange}
              // onRowsPerPageChange={handleRowsPerPageChange}
            >
              {(!PMTList || (PMTList.length == 0)) && (
                <>
                  <Typography variant="h6" mt={3} ml={3} gutterBottom>
                    ไม่พบข้อมูล
                  </Typography>
                </>
              )}
              {PMTList.map((data, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{data.dev_eui}</TableCell>
                  <TableCell align="center">{data.dev_name}</TableCell>
                  <TableCell align="center">{data.status}</TableCell>
                  <TableCell align="center">{data.occupied_id ? data.occupied_id : '-'}</TableCell>
                  <TableCell align="center">{data.firstname ? data.firstname + " " + data.lastname : '-'}</TableCell>
                  <TableCell align="center">
                    <Button
                      component={Link}
                      to={`/tracking-card/PMT/${data.id}`}
                      variant="contained"
                      color="success"
                    >
                      ข้อมูล
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </Box>
        </TabPanel>
        <TabPanel value={TrackingCardTab.VHM}>
        <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="หมายเลขบัตร"
              variant="outlined"
              placeholder="หมายเลขบัตร"
              value={filterDeviceIDVHM}
              onChange={(e) => {
                setFilterDeviceIDVHM(e.target.value);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="เลขบัตรประชาชน"
              variant="outlined"
              placeholder="เลขบัตรประชาชน"
              value={filterIDVHM}
              onChange={(e) => {
                setFilterIDVHM(e.target.value);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="ทะเบียนรถ"
              variant="outlined"
              placeholder="ทะเบียนรถ"
              value={filterLicenseVHM}
              onChange={(e) => {
                setFilterLicenseVHM(e.target.value);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <FormControl fullWidth>
              <InputLabel id="select-status-label">สถานะ</InputLabel>
              <Select
                labelId="select-status-label"
                value={filterStatusVHM}
                label="สถานะ"
                name="status"
                onChange={(e) => setFilterStatusVHM(e.target.value)}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                <MenuItem value="install">install</MenuItem>
                <MenuItem value="uninstall">uninstall</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
          <Box sx={{ padding: '24px 0' }}>
            <Table
              heads={['หมายเลขบัตร', 'ชื่ออุปกรณ์', 'ประเภท', 'สถานะ', 'เลขบัตรประชาชน', 'ชื่อ นามสกุล', 'ทะเบียนรถ']}
              count={VHMList.length}
              // page={page}
              // rowsPerPage={rowsPerPage}
              // onPageChange={handlePageChange}
              // onRowsPerPageChange={handleRowsPerPageChange}
            >
              {(!VHMList || (VHMList.length == 0)) && (
              <>
                <Typography variant="h6" mt={3} ml={3} gutterBottom>
                ไม่พบข้อมูล
                </Typography>
              </>
            )}
              {VHMList.map((data, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{data.imei_id}</TableCell>
                  <TableCell align="center">{data.Device_name}</TableCell>
                  <TableCell align="center">{data.Device_type}</TableCell>
                  <TableCell align="center">{data.status}</TableCell>
                  <TableCell align="center">{data?.person_id}</TableCell>
                  <TableCell align="center">{data?.firstname} {data?.lastname}</TableCell>
                  <TableCell align="center">{data?.license_plate}</TableCell>
                  {/* <TableCell align="center">
                    <Button
                      component={Link}
                      to={`/tracking-card/VHM/${data._id}`}
                      variant="contained"
                      color="success"
                    >
                      ข้อมูล
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))}
            </Table>
          </Box>
        </TabPanel>
      </TabContext>
    </Container>
  );
};

export default TrackingCard;

const Container = styled('div')`
  padding: 24px;
`;
